(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apply-warranty"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('warranty-form');
    const popup = document.querySelector('#warranty-popup');
    const closeBtn = document.querySelector('#close-popup');

    // CAPTCHA Logic
    const captchaQuestion = document.getElementById('captcha-question');
    const captchaAnswer = document.getElementById('captcha-answer');
    const captchaExpected = document.getElementById('captcha-expected');

    function generateCaptcha() {
      const num1 = Math.floor(Math.random() * 10) + 1;
      const num2 = Math.floor(Math.random() * 10) + 1;
      captchaQuestion.textContent = `${num1} + ${num2}`;
      captchaExpected.value = num1 + num2;
    }

    generateCaptcha();

    // Set Date of Purchase limits (from 1 year ago to today)
    const dateInput = document.getElementById('warranty-date');
    if (dateInput) {
      const today = new Date();
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(today.getFullYear() - 1);

      // Format to YYYY-MM-DD
      const formatDate = (d) => d.toISOString().split('T')[0];

      dateInput.max = formatDate(today);
      dateInput.min = formatDate(oneYearAgo);
    }

    function showError(input, message) {
      input.classList.add('is-invalid');
      input.style.borderColor = 'red';
      let errorSpan = input.nextElementSibling;
      if (!errorSpan || !errorSpan.classList.contains('error-msg')) {
        errorSpan = document.createElement('span');
        errorSpan.classList.add('error-msg');
        errorSpan.style.color = 'red';
        errorSpan.style.fontSize = '12px';
        errorSpan.style.display = 'block';
        errorSpan.style.marginTop = '4px';

        if (input.type === 'checkbox') {
          input.parentElement.parentElement.appendChild(errorSpan);
        } else {
          input.parentNode.insertBefore(errorSpan, input.nextSibling);
        }
      }
      errorSpan.textContent = message;
    }

    function clearErrors() {
      const inputs = form.querySelectorAll('input, select, textarea');
      inputs.forEach((input) => {
        input.classList.remove('is-invalid');
        input.style.borderColor = '';
      });
      const errors = form.querySelectorAll('.error-msg');
      errors.forEach((err) => err.remove());
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearErrors();
      let hasError = false;

      if (!form.name.value.trim()) {
        showError(form.name, 'Please enter your name.');
        hasError = true;
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(form.email.value.trim())) {
        showError(form.email, 'Please enter a valid email address.');
        hasError = true;
      }

      const phoneValue = form.phone.value.trim().replace(/\D/g, '');
      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(phoneValue)) {
        showError(form.phone, 'Please enter a valid 10-digit Indian phone number starting with 6-9.');
        hasError = true;
      }

      if (!form.city.value.trim()) {
        showError(form.city, 'Please enter your city.');
        hasError = true;
      }

      if (!form.date.value) {
        showError(form.date, 'Please select the date of purchase.');
        hasError = true;
      } else {
        const selectedDate = new Date(form.date.value);
        const currentDate = new Date();
        currentDate.setHours(23, 59, 59, 999);

        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        oneYearAgo.setHours(0, 0, 0, 0);

        if (selectedDate > currentDate) {
          showError(form.date, 'Purchase date cannot be in the future.');
          hasError = true;
        } else if (selectedDate < oneYearAgo) {
          showError(form.date, 'Purchase date must be within the last 1 year.');
          hasError = true;
        }
      }

      if (!form.invoice_no.value.trim()) {
        showError(form.invoice_no, 'Please enter your invoice number.');
        hasError = true;
      }

      if (!form.purchased_source.value) {
        showError(form.purchased_source, 'Please select a purchase source.');
        hasError = true;
      }

      if (!form.product.value) {
        showError(form.product, 'Please select a product.');
        hasError = true;
      }

      if (!form.age_group.value) {
        showError(form.age_group, "Please select the user's age group.");
        hasError = true;
      }

      if (!form.gender.value) {
        showError(form.gender, "Please select the user's gender.");
        hasError = true;
      }

      if (!form.primary_users.value) {
        showError(form.primary_users, 'Please select the primary users.');
        hasError = true;
      }

      const termCheckbox = form.querySelector('.form-check-input');
      if (termCheckbox && !termCheckbox.checked) {
        showError(termCheckbox, 'Please agree to the Terms & Conditions.');
        hasError = true;
      }

      if (parseInt(captchaAnswer.value.trim(), 10) !== parseInt(captchaExpected.value, 10)) {
        showError(captchaAnswer, 'Incorrect CAPTCHA answer. Please try again.');
        generateCaptcha();
        captchaAnswer.value = '';
        hasError = true;
      }

      if (hasError) {
        // Focus on the first field with an error
        const firstError = form.querySelector('.is-invalid');
        if (firstError) firstError.focus();
        return;
      }

      const formData = {
        name: form.name.value,
        email: form.email.value,
        phone: phoneValue,
        city: form.city.value,
        date: form.date.value,
        invoice_no: form.invoice_no.value,
        purchased_source: form.purchased_source.value,
        product: form.product.value,
        message: form.message.value,
        page_url: window.location.href,
        age_group: form.age_group.value,
        gender: form.gender.value,
        primary_users: form.primary_users.value,
      };

      try {
        await fetch(
          'https://script.google.com/macros/s/AKfycbyRoGDsuid4FarrxgW3KqpCXRkrCv7K-Zx5A9t-24mncbxiNxLfHcv3GjsnV5B-IJo/exec',
          {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          }
        );

        popup.style.display = 'flex';
        form.reset();
        generateCaptcha();
      } catch (err) {
        alert('Error submitting form. Please try again.');
        console.error(err);
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
    $('[name="type"]').on("change", function() {
    const placeholder = $(this).data("placeholder");

    // Update the label text
    $(".order_id").text(placeholder);

    });


  $("#tracking-form").validate({
      rules: {
          order_id: {
              required: true,
          },
          phone: {
              required: true,
          },
      },
      messages: {
          order_id: {
              required: "Please enter order number",
          },
          phone: {
              required: "Please enter phone number",
          },
      },
      errorPlacement: function(error, element) {
          var placement = $(element).data('error');
          if (placement) {
              $(placement).html(error)
          } else {
              error.insertAfter(element);
          }
      },
      submitHandler: function(form) {

          $(this).find('[type=submit]').attr('disabled', '');

          let formdata = new FormData(form);
          formdata.append('shop', Shopify.shop);
            if ((formdata.get('phone')).length !== 10) {
                $(".ajax-message").html('<div class="mm-alert mm-alert-danger">{{"custom.track_order.error_phone" | t }}</div>');
                 return false;
            }

            $.ajax({
                url: "https://api-tygatec.kartlog.in/v1/order/track",
                type: 'POST',
                data: formdata,
                contentType: false,
                processData: false,
                beforeSend: function() {
                  $(".order-details").html('');
                    $(".ajax-message").html(
                        '<div class="mm-alert mm-alert-info"><i class="fa fa-refresh fa-spin"></i> Please wait... </div>'
                    );
                },
                success: function(res) {
                  window.location.href= res.data.tracking_url;
                    $(".ajax-message").html('');
             
                },
                complete: function() {
                    $(this).find('[type=submit]').removeAttr('disabled');
                  
                },
                error: function(data) {
                    let response = JSON.parse(data.responseText);
                    if (data.status === 422) {
                        let errorString = '<ul class="ps-3 m-0">';
                        $.each(response.errors, function(key, value) {
                            errorString += '<li>' + value + '</li>';
                        });
                        errorString += '</ul>';
                        response = errorString;
                    } else {
                        response = response.message;
                    }

                    $(".ajax-message").html('<div class="mm-alert mm-alert-danger">' + response +
                        '</div>');
                }
            });
          
        
          
          return false;
      }
    });

  } catch(e) { console.error(e); }
})();
})();
